import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import {
  getSalesByIdSlice,
  receiptDueAmountSlice,
  resetReciveAmountMessage,
  resetMessage,
} from "../../../store/slices/sales";
import { getaccountType } from "../../../store/slices/accountType";
import { getBankListSlice } from "../../../store/slices/bankSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";

import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";

const ReceiptForm = () => {
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { salesById } = useSelector((state) => state.sales);
  const { accountType } = useSelector((state) => state.accountType);
  const { bank } = useSelector((state) => state.bank);
  const { token } = useSelector((state) => state.auth);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const receiptId = sessionStorage.getItem("receiptId");
  const totalAmount = salesById?.sale?.TotalDueAmount || 0;
   const clinicId =clinicInfo?.[0]?.clinicId ||null;
  const clinicObjId = clinicInfo?.[0]?._id; 
  const [formData, setFormData] = useState({
    accountType: null,
    bank: null,
    paidAmount: 0,
    dueAmount: 0,
  });
  useEffect(() => {
    if (salesById) {
      setFormData({
        accountType: salesById?.sale?.accountType
          ? {
              value: salesById?.sale?.accountType._id,
              label: salesById?.sale?.accountType.name,
            }
          : null,
        bank: salesById?.sale?.bank
          ? {
              value: salesById?.sale?.bank._id,
              label: salesById?.sale?.bank.name,
            }
          : null,
      });
    }
  }, [salesById]);

  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const {
    createSalesSuccessMessage,
    createSalesErrorMessage,
    reciveAmountSuccessMessage,
    reciveAmountErrorMessage,
  } = useSelector((state) => state.sales);

  useEffect(() => {
    dispatch(getaccountType({ status: ["Active"], token }));
    dispatch(
      getBankListSlice({
        status: ["Active"],
        clinicId,
        token,
      })
    );
  }, [dispatch, clinicInfo, token]);

  useEffect(() => {
    if (receiptId) {
      dispatch(getSalesByIdSlice({ id: receiptId, token }));
    }
  }, [dispatch, receiptId, token]);

  useEffect(() => {
    showTostifyMessageAndReset(
      createSalesSuccessMessage,
      showToastifySuccess,
      resetMessage
    );
    showTostifyMessageAndReset(
      createSalesErrorMessage,
      showToastifyError,
      resetMessage
    );
    showTostifyMessageAndReset(
      reciveAmountSuccessMessage,
      showToastifySuccess,
      resetReciveAmountMessage
    );
    showTostifyMessageAndReset(
      reciveAmountErrorMessage,
      showToastifyError,
      resetReciveAmountMessage
    );
  }, [
    createSalesSuccessMessage,
    createSalesErrorMessage,
    reciveAmountSuccessMessage,
    reciveAmountErrorMessage,
    showTostifyMessageAndReset,
  ]);

  const handleChange = (selectedOption, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: selectedOption,
    }));

    if (field === "accountType") {
      setFormData((prev) => ({
        ...prev,
        bank: null,
      }));
    }
  };
  const filteredBanks = formData?.accountType
    ? bank?.filter(
        (b) =>
          b?.accountType && b?.accountType._id === formData?.accountType?.value
      )
    : [];
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = parseFloat(value);

    if (name === "paidAmount") {
      if (parsedValue > totalAmount) {
        setError("Paid amount cannot exceed the total amount.");
      } else {
        setError("");
      }

      setFormData({
        ...formData,
        [name]: value,
        dueAmount: Math.max(totalAmount - parsedValue, 0),
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    if (salesById) {
      setFormData((prev) => ({
        ...prev,
        totalAmount: salesById?.sale?.TotalDueAmount || 0,
        dueAmount: salesById?.sale?.TotalDueAmount || 0,
      }));
    }
  }, [salesById]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const localFormData = {
      token,
      salesId: salesById?.sale?._id,
      clinicId,
      accountType: formData?.accountType?.value,
      bank: formData.bank?.value,
      paidAmount: formData?.paidAmount,
      dueAmount: formData?.dueAmount,
      createdBy: clinicObjId,
      receivedBy: clinicInfo[0]?.userId?._id,
    };

    dispatch(receiptDueAmountSlice(localFormData, token)).then(() => {
      dispatch(getSalesByIdSlice({ id: receiptId, token }));
    });
    setFormData({
      paidAmount: "",
    });
  };
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            Reciept <span className="bold-text">{salesById?.sale?.date}</span>
            <span className="float-end">
              <span className="bold-text">Status:</span>{" "}
              {salesById?.sale?.status || "N/A"}
            </span>
          </div>
          <div className="card-body">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="basic-form">
                    <form onSubmit={(e) => e.preventDefault()}>
                      <div className="row">
                        <div className="form-group mb-3 col-md-6">
                          <label>Name</label>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              salesById?.sale?.invoiceId[0]?.appointmentDetails
                                ?.patientName
                            }
                            readOnly
                          />
                        </div>
                        <div className="form-group mb-3 col-md-6">
                          <label>Invoice Number</label>
                          <input
                            type="text"
                            className="form-control"
                            value={salesById?.sale?.invoiceId[0]?.invoiceId}
                            readOnly
                          />
                        </div>
                        <div className="form-group mb-3 col-md-6">
                          <label className="col-form-label">
                            Account Type:
                          </label>
                          <Select
                            value={formData.accountType}
                            placeholder="Select Account Type"
                            isDisabled={true}
                          />
                        </div>
                        <div className="form-group mb-3 col-md-6">
                          <label className="col-form-label">Bank:</label>
                          <Select
                            value={formData.bank}
                            isDisabled={true}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6 col-sm-3"></div>
              <div className="col-lg-6 col-sm-9 ms-auto">
                <table className="table table-clear">
                  <tbody>
                    <tr>
                      <td className="left bold-text">Total Amount</td>
                      <td>
                        <strong>Rs: {salesById?.sale?.totalPrice}</strong>
                      </td>
                    </tr>

                    <tr>
                      <td className="fw-bold">Paid Amount</td>
                      <td>
                        <input
                          type="number"
                          className={`form-control ${
                            error ? "is-invalid" : ""
                          }`}
                          name="paidAmount"
                          value={formData.paidAmount}
                          onChange={handleInputChange}
                          placeholder="Enter Paid Amount"
                        />
                        {error && (
                          <div className="invalid-feedback">{error}</div>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Due Amount</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="dueAmount"
                          value={formData.dueAmount || 0}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button
                          onClick={handleSubmit}
                          className="btn btn-primary"
                          disabled={error !== "" || formData.paidAmount === ""}
                          style={{ position: "relative", left: 271 }}
                        >
                          Receive Payment
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptForm;
